// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Stage_Tabs__3PojS","DatePicker":"Stage_DatePicker__2TRJT"};